<template>
    <div class="row">
        <div class="col">
            <!--<h5 class="h5 my-4" v-if="lessons.length">Оберіть предмет</h5>-->

            <div class="row">
                <div class="col col-lg-3 col-md-4 col-sm-6" v-for="(lesson, index) in lessons" :key="index">
                    <router-link :to="{name: 'math-topics', query: {subject_id: lesson.subject_id, base_classe: lesson.base_classe}}" class="text-white">
                        <div class="card card-pretty mx-auto">
                            <div class="card-body d-flex justify-content-center">
                                <h3 class="card-title d-flex align-items-center">
                                    <span>{{ lesson.subject_name }}</span>&nbsp;<span>{{ lesson.base_classe }}</span>
                                </h3>
                                <!--<p class="card-text">
                                    <span>{{ lesson.subject_name }}</span> <span>{{ lesson.base_classe }}</span>
                                </p>-->
                                <!--<a href="#" class="btn btn-primary">Go somewhere</a>-->
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'math-lessons',
        data() {
            return {
                lessons: []
            };
        },
        mounted() {
            this.renderLessons();
        },
        methods: {
            renderLessons() {
                //console.log(appConfig);
                api.get(`public/lessons`).then(response => {
                    this.lessons = response.data.gist;
                    //this.packageItem = response.data.gist;
                    //this.$emit('afterVideoSearch', this.packageItem);
                });
            }
        }
    }
</script>

<style scoped>
    .card-pretty {
        height: 130px;
        max-width: 320px;
        overflow: hidden;
        transition: .1s;
        /*background: url("../assets/img/subject-bg.png") no-repeat 100% 100%/auto 100%, linear-gradient(to bottom right, #fff, rgba(1, 199, 254, 0.3));*/
        /*background: url("../assets/img/subject-bg.png") no-repeat 100% 100%/auto 100%, linear-gradient(to bottom right, #fff, rgba(0, 0, 0, 0.6));*/
        background: url("../assets/img/subject-bg.png") no-repeat 100% 100%/auto 100%, linear-gradient(to bottom right, #fff, rgba(70, 127, 130, 0.8));
        margin-bottom: 30px;
    }

    .card-pretty:hover { background-size: auto 110%; box-shadow: 0 15px 45px rgba(0,0,0,.1); z-index: 1; }

    .card-pretty h5 { font-weight: bold; }
    /*.card-pretty h5 { font-weight: bold; color: #425365; }*/
    /*.card-pretty:hover h5 { color: #3c8dbc; }*/
    a:hover { text-decoration: none; }
</style>